/* eslint-disable @typescript-eslint/naming-convention */
import { CORE } from './vi/core';

export const locale = {
    lang: 'vi',
    data: {
        CORE
    }
};
